import { render, staticRenderFns } from "./SithMesStoolPurchasingGroupEdit.vue?vue&type=template&id=2cb714f0&"
import script from "./SithMesStoolPurchasingGroupEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolPurchasingGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports